import { useEffect } from "react";
import Body from "./Body";
import Footer from "./Footer";
import Header from "./Header";
import Sidebar from "./Sidebar";
import SidebarMenu from "./SidebarMenu.js";
import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
} from "@azure/msal-react";
// import { AuthenticatedTemplate, UnauthenticatedTemplate } from "../mock";
import { Route, Routes } from "react-router-dom";
import LogoutPage from "../auth/LogoutPage";
//import LogoutPage from "../mock/LogoutPage";

export default function Layout(props = {}) {
  useEffect(() => {});

  return (
    <div>
      <Header
        userFullName={props.userFullName}
        appName={
          <div
            style={{
              height: "46px",
              padding: "5px",
            }}
          >
            <span className="logo-lg">
              <strong>PFAS</strong>
            </span>
          </div>
        }
      />
      <AuthenticatedTemplate>
        <Sidebar menu={SidebarMenu} />
        <Body {...props} />
      </AuthenticatedTemplate>
      <UnauthenticatedTemplate>
        <div className="content-wrapper">
          <section className="content body">
            <div className="row">
              Please login to continue
              <Routes>
                <Route exact={true} path="/logout" element={<LogoutPage />} />
              </Routes>
            </div>
          </section>
        </div>
      </UnauthenticatedTemplate>
      <Footer version="1.0.0" />
    </div>
  );
}
